export enum FlightBookQueryParams {
  TRIP_ID = "tripId",
  OUTGOING_FARE_ID = "outgoingFareId",
  RETURN_FARE_ID = "returnFareId",
}

export enum SliceDirection {
  Outbound = "Outbound",
  Return = "Return",
}
